// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, of, throwError } from 'rxjs';

// Service
import { ApiService } from '../api/api.service';

// Helpers
import { Base64 } from '../../lib/helpers/utils';
import { isUndefined, isEmptyObject } from '../../lib/helpers/utils';

// Models
import { Cart, CartHelper } from '../../models/b2b/cart';
import { CartPromoHelper } from '../../models/b2b/cartPromo';
import { ProductHelper } from '../../models/b2b/product';
import { Shipping } from '../../models/b2b/shipping';
import { ShippingOption } from '../../models/b2b/shippingOption';
import { User, UserHelper } from '../../models/b2b/user';
import { CartItemHelper } from '../../models/b2b/cartItem';
import { CartItem } from '../../models/b2b/cartItem';
import { Checkout } from '../../models/b2b/checkout';
import { SaldoPromocionesHelper } from '../../models/b2b/saldoPromocionesItem';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { AppState } from 'app/store';
import { Store } from '@ngrx/store';
import { Subscriber } from 'app/shared/lib/helpers/subscriber';

@Injectable()
export class SoledadCartService extends Subscriber {
    // Promo Validation
    hasPromotions: boolean = false;
    promoCodeAplicado: string = undefined;

    // Promo Alerts Messages
    alerts = {
        msgs: {},
        shown: false
    };

    clienteCodigo: string;
    constructor(
        private api: ApiService,
        private store: Store<AppState>
    ) {
        super();
        this.addSubscription(
            this.store
                .select((state) => state.user.data.clienteCodigo)
                .subscribe((clienteCodigo) => {
                    this.clienteCodigo = clienteCodigo;
                })
        );
    }

    validateItems(
        user: User,
        c: Cart,
        recalculate: boolean = true,
        parts: boolean = false,
        modParts: boolean = false,
        checkout: Checkout = undefined
    ): Observable<Cart> {
        const params = [];
        const origen = document.baseURI;

        let items: CartItem[];
        this.alerts = {
            msgs: {},
            shown: false
        };

        let cart = _.cloneDeep(c);
        // Get Cart Items
        if (!isUndefined(cart)) {
            items = CartHelper.getItems(cart);
        }

        // Empty Cart
        if (isEmptyObject(items) && !parts) {
            this.saveCart(user.clienteCodigo, cart);
            return of(cart);
        }

        // No User
        if (!user) {
            return of(cart);
        }
        // User main address or checkout address
        const address = checkout && checkout.address ? checkout.address : UserHelper.getSelectedAddress(user);

        // console.log('cart user', user);
        // console.log('cart address', address);
        params['ALMACEN'] = address.almacenCodigo;
        params['DIRECCIONENVIO'] = address.codigo;
        params['AGENCIA'] = address.agencia.trim();

        params['IDIOMA'] = 'es';
        params['CLIENTE'] = user.clienteCodigo;
        params['OBSERVACIONES'] = '';
        params['ORIGEN'] = origen;
        // params['OBSERVACIONES'] = (observations === undefined) ? '' : observations;

        if (parts) {
            params['RECAMBIOS'] = true;
        }

        if (modParts) {
            params['OPERACION'] = 'MODIFICAR';
        }

        const rows = [];

        const map_items_codigos = {};

        if (items && items.length) {
            for (const item of items) {
                if (item.parts && !modParts) {
                    params['RECAMBIOS'] = true;
                    //continue;
                }

                const row = [];
                const product = item.product;

                map_items_codigos[product.info.codigo] = item;

                row.push('DESCRIPCION=>' + product.info.nombre);
                row.push('CANTIDAD=>' + item.quantity);

                if (!recalculate) {
                    row.push('PRECIOMOSTRAR=>' + item.precioSinDescuento);
                    row.push('PRECIO=>' + item.precioSinDescuento);
                } else {
                    const precioMostrar = product.rates.base.precioMostrarPedido; // item.priceO;
                    const precio =
                        item.precioSinDescuento === 0 ? product.rates.base.precioSinDescuento : item.precioSinDescuento; // item.priceO;

                    row.push('PRECIOMOSTRAR=>' + precioMostrar);
                    row.push('PRECIO=>' + precio);
                }

                row.push('PROMOCION=>' + product.rates.base.prePrm);
                row.push('DTO1=>' + product.rates.base.preDto1);
                row.push('DTO2=>' + product.rates.base.preDto2);
                row.push('DTO3=>' + product.rates.base.preDto3);
                row.push('DTO4=>' + product.rates.base.preDto4);
                row.push('DTO5=>' + product.rates.base.preDto5);

                if (item.parts) {
                    const json = JSON.parse(item.json);
                    for (let key in json) {
                        json[key].cantidad = item.quantity;
                    }

                    row.push('UNIDADMEDIDA=>' + '');
                    row.push('TIEMPO=>' + item.shippings[0].tiempo2);
                    row.push('ALMACEN=>' + item.shippings[0].almacenCodigo);
                    row.push('ARTICULO=>' + item.product_id);
                    row.push('EXTERNO=>' + true);
                    row.push('JSON_EXTERNO=>' + JSON.stringify(json));
                } else {
                    row.push('UNIDADMEDIDA=>' + product.info.unidadMedida);
                    row.push('TIEMPO=>' + product.horas);
                    row.push('ALMACEN=>' + address.almacenCodigo);
                    row.push('ARTICULO=>' + product.info.codigo.trim());
                    row.push('EXTERNO=>' + false);
                }

                const shippings = item.shippings;
                let found = false;
                shippings.forEach((value) => {
                    if (value.shippingOptionSelected && Number(value.shippingOptionSelected) > 0 && !found) {
                        row.push('TIPOENTREGA=>' + value.shippingOptionSelected);
                        // sessionStorage.setItem('ALM_' + value.almacenCodigo + '_ITEMID_'+item.product_id, value.shippingOptionSelected);
                        found = true;
                    }
                });

                if (!found) {
                    row.push('TIPOENTREGA=>' + '-1');
                }

                rows.push(row.join('&&'));

                // if ( item.precioModificado ) no_recalcular = true;
            }
        }

        // params['RECALCULAR'] = true;
        if (!recalculate) {
            params['RECALCULAR'] = recalculate;
        }
        // params['RECALCULAR'] = true;
        params['ROWS'] = Base64.encode(rows.join('##') + '##');

        cart.promoCode.trim() ? (params['PROMOCODE'] = cart.promoCode) : '';

        // params['RECAMBIOS']  = true;

        // console.log('ROWS', rows);
        // console.log('PARAMS', params);
        // Call
        return this.api.callSoledad('b2bNew.dbo.HTML_PedidosConfirmacion', params).pipe(
            map((data) => {
                if (data && data.result === 0 && data.value) {
                    // console.log('HTML_PedidosConfirmacion!!', data);
                    // Clear promos to get new validated promos
                    cart.promos = [];
                    cart.promoCode = '';
                    this.promoCodeAplicado = '';
                    cart.saldoConseguido = 0;

                    const map_items_entregas = {};
                    let index = 1;
                    let item = null;
                    let partItems = [];
                    let i = 0;
                    // Recorrido por los rows para exraer información
                    for (const row of data.value) {
                        cart.idPromo = row['IDPROMO'];

                        if (i === 0) {
                            cart.saldoPromociones = null;
                            if (row['SALDO_PROMOCIONES']) {
                                cart.saldoPromociones = SaldoPromocionesHelper.fromAPI(
                                    JSON.parse(row['SALDO_PROMOCIONES'])
                                );
                            }
                        }

                        // cart.saldoPromociones = SaldoPromocionesHelper.mock();

                        if (row['TIPOREGALO'] === 'SALDO') {
                            cart.saldoConseguido += row['CANTIDAD'];
                        }

                        // Error especial
                        if (data.value[0].ERROR) {
                            CartHelper.cleanValidatingCartItems(cart);
                            throw throwError('ERROR ' + data.value[0].ERROR);
                        }

                        // Checkout Coupon PromoCode
                        if (row['PROMOCODE'] && row['PROMOCODE'].length > 0) {
                            /*cart.promoCode = */ this.promoCodeAplicado = row['PROMOCODE'];
                            // console.log(this.promoCodeAplicado);
                        } /* else {
                            cart.promoCode = '';
                        }*/

                        // Row of type PROMO
                        if (row['ALMACEN_CODIGO'] === -1) {
                            const promo = CartPromoHelper.transformFromApi(row);
                            cart.promos.push(promo);
                            // Registro de alertas
                            this.addAlert(promo.description, 0, promo);
                            this.hasPromotions = true;
                        }

                        // Row of type PRODUCT
                        if (row['ALMACEN_CODIGO'] !== -1) {
                            if (row['EXTERNO']) {
                                partItems.push(row);
                            } else {
                                // Registro de alertas
                                if (row['AVISO_MENSAJE_1'].length > 0) {
                                    this.addAlert(row['AVISO_MENSAJE_1'], row['AVISO_PRIORIDAD_1'], row);
                                }
                                if (row['AVISO_MENSAJE_2'].length > 0) {
                                    this.addAlert(row['AVISO_MENSAJE_2'], row['AVISO_PRIORIDAD_2'], row);
                                }
                                if (row['AVISO_MENSAJE_3'].length > 0) {
                                    this.addAlert(row['AVISO_MENSAJE_3'], row['AVISO_PRIORIDAD_3'], row);
                                }

                                const product_id = row['ARTICULO'];

                                // Session ID - Same for all lines
                                cart.sessionId = row['SESIONID'];

                                // Primera referencia del artículo
                                if (!map_items_entregas[product_id]) {
                                    item = map_items_codigos[product_id];

                                    map_items_entregas[product_id] = item;

                                    item.shippings = [];

                                    const precio = Math.round(row['PRECIO'] * 100) / 100;

                                    item.product.rates.base.precioMostrarBusqueda = precio;
                                    item.product.rates.base.precioSinDescuento = row['PRECIOSINDESCUENTO'];
                                    item.product.rates.base.preDto1 = row['DTO1'];
                                    item.product.rates.base.preDto2 = row['DTO2'];
                                    item.totalLinea = row['TOTAL'];
                                    item.totalLineaSinDescuento = row['TOTAL'];

                                    item.precioConDescuento = row['PRECIO'];
                                    item.precioSinDescuento = row['PRECIOSINDESCUENTO'];

                                    item.portesTipoEntrega = row['PORTES_TIPO_ENTREGA'];

                                    recalculate ? (item.price = item.priceO = row['PRECIO']) : '';

                                    ProductHelper.applyIncrement(item.product);
                                    index = 1;
                                } else {
                                    index++;
                                }

                                // Appends sends
                                const shipping = new Shipping();
                                shipping.agencia = row['AGENCIA'].trim();
                                shipping.almacen = row['ALMACEN'];
                                shipping.almacenCodigo = row['ALMACEN_CODIGO'];
                                shipping.tiempo = row['TIEMPO'];
                                shipping.cantidad = row['CANTIDAD'];
                                shipping.descripcion = row['DESCRIPCION'];
                                shipping.total = row['TOTAL'];
                                shipping.colorEntrega = row['COLORENTREGA'] ? row['COLORENTREGA'] : 0;

                                // Shipping creation
                                if (row['ENTREGAS_DISPONIBLES']) {
                                    // let apiShippingOptions = JSON.parse(row["ENTREGAS_DISPONIBLES"]);
                                    try {
                                        const apiShippingOptions = JSON.parse(row['ENTREGAS_DISPONIBLES']);
                                        if ('entregas' in apiShippingOptions) {
                                            for (const apiShipping of apiShippingOptions.entregas) {
                                                const shippingOption = new ShippingOption();
                                                shippingOption.id = apiShipping.id;
                                                shippingOption.tipoEntrega = apiShipping.tipoEntrega;
                                                shippingOption.descripcion = apiShipping.descripcion;
                                                shippingOption.orden = apiShipping.orden;
                                                shippingOption.seleccionado = apiShipping.seleccionado === '1';
                                                shippingOption.descuento = apiShipping.descuento
                                                    ? apiShipping.descuento
                                                    : 0;
                                                shippingOption.fechaEntrega = apiShipping.fechaEntrega;
                                                shipping.shippingOptions.push(shippingOption);

                                                if (shippingOption.seleccionado) {
                                                    shipping.shippingOptionSelected = shippingOption.id;
                                                }

                                                // if (sessionStorage.getItem('ALM_'+shipping.almacenCodigo+'_ITEMID_'+product_id)) {
                                                //     shipping.shippingOptionSelected = sessionStorage.getItem('ALM_'+shipping.almacenCodigo+'_ITEMID_'+product_id);
                                                //     sessionStorage.removeItem('ALM_'+shipping.almacenCodigo+'_ITEMID_'+product_id);
                                                // }
                                            }

                                            if (!shipping.shippingOptionSelected) {
                                                shipping.shippingOptionSelected = '-1';
                                            }
                                        }
                                    } catch (msg) {
                                        console.log('[cart][validateItems] Error formato json entregas');
                                    }
                                }

                                item.shippings.push(shipping);
                            }
                        }
                        i++;
                    }
                    if (partItems.length > 0) {
                        const items = CartHelper.getItems(cart);
                        for (const partItem of partItems) {
                            // If items it is not on the cart then we add it
                            const found = items.find((item, index) => {
                                return item.product_id === partItem['ARTICULO'];
                            });

                            if (!found) {
                                const cartItem = CartItemHelper.createFromPart(partItem);

                                items.push(cartItem);
                                CartHelper.addPart(cart, cartItem);
                            }
                        }
                    } else {
                        CartHelper.removePartsItems(cart);
                    }

                    // Merge items with current cart
                    CartHelper.mergeItems(cart, items, recalculate);

                    // console.log(cart);

                    this.saveCart(user.clienteCodigo, cart);

                    return cart;
                } else {
                    CartHelper.removePartsItems(cart);

                    return cart;
                }
            })
        );
    }

    // JSON Stringify
    toJson(cart: Cart) {
        const json = JSON.stringify(cart);
        return json;
    }

    // JSON Parse
    fromJson(user: User, json: string): Cart {
        if (json) {
            const cart = JSON.parse(json);
        }
        return null;
    }

    // Load cart from SessionStorage
    loadCart(clienteCodigo: string): Cart {
        if (clienteCodigo) {
            // const jsonSession = sessionStorage.getItem(user.clienteCodigo + 'cart');
            // const jsonLocal   = localStorage.getItem(user.clienteCodigo + 'cart');

            // const json = (jsonLocal) ? jsonLocal : jsonSession;
            return JSON.parse(localStorage.getItem(clienteCodigo + 'cart'));
        }
    }

    // Save cart on SessionStorage
    saveCart(clienteCodigo: string, cart: Cart) {
        const json = this.toJson(cart);
        //sessionStorage.setItem(user.clienteCodigo + 'cart', json);
        localStorage.setItem(clienteCodigo + 'cart', json);
    }

    // Empty cart on SessionStorage
    clear(clienteCodigo: string = null): Cart {
        const newCart = CartHelper.create();
        const codigo = clienteCodigo || this.clienteCodigo;
        this.saveCart(codigo, newCart);
        return newCart;
    }

    // Get Alert Promos and Messages for Checkout
    addAlert(message, priority, item): void {
        // console.log('addAlert', message, priority, item);

        const id = 'P' + priority;

        if (!this.alerts.msgs[id]) {
            this.alerts.msgs[id] = {};
        }
        this.alerts.msgs[id].msg = message;

        if (!this.alerts.msgs[id].rows) {
            this.alerts.msgs[id].rows = [];
        }
        this.alerts.msgs[id].rows.push(item);

        // console.log(this.alerts);
    }

    getAlerts(): any {
        return this.alerts;
    }

    getPromoCodeAplicado(): string {
        return this.promoCodeAplicado;
    }
}
